/** Currency context — INR/USD/EUR/GBP/AUD/CAD with localStorage persistence.
 *  Mirrors the blueprint engine's CURRENCIES map so amounts can be rendered consistently.
 *  Rates are placeholders; in production they will be sourced from System Settings (CMS).
 */
import { createContext, useContext, useEffect, useState, useCallback } from "react";

export const CURRENCIES = {
  INR: { sym: "₹", rate: 1, locale: "en-IN" },
  USD: { sym: "$", rate: 0.012, locale: "en-US" },
  EUR: { sym: "€", rate: 0.011, locale: "en-US" },
  GBP: { sym: "£", rate: 0.0095, locale: "en-US" },
  AUD: { sym: "A$", rate: 0.018, locale: "en-US" },
  CAD: { sym: "C$", rate: 0.016, locale: "en-US" },
};

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem("nvl-cur") || "INR");

  useEffect(() => {
    localStorage.setItem("nvl-cur", code);
  }, [code]);

  const format = useCallback(
    (inrAmount) => {
      const c = CURRENCIES[code] || CURRENCIES.INR;
      const n = Math.round((Number(inrAmount) || 0) * c.rate);
      return `${c.sym}${n.toLocaleString(c.locale)}`;
    },
    [code]
  );

  return (
    <CurrencyContext.Provider value={{ code, setCode, format, currencies: CURRENCIES }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used inside CurrencyProvider");
  return ctx;
}
